function getCurrencyCode(currencyCode) {
    const currencySymbols = {
        "USD": "$",
        "FJD":"$",
        "EUR": "€",
        "JPY": "¥",
        "GBP": "£",
        "AUD": "$",
        "CAD": "$",
        "CHF": "Fr",
        "CNY": "¥",
        "SEK": "kr",
        "NZD": "$",
        "KRW": "₩",
        "SGD": "$",
        "NOK": "kr",
        "MXN": "$",
        "INR": "₹",
        "RUB": "₽",
        "ZAR": "R",
        "BRL": "R$",
        "TRY": "₺",
        "HKD": "HK$",
        "IDR": "Rp",
        "ISK": "kr",
        "PHP": "₱",
        "DKK": "kr",
        "PLN": "zł",
        "HUF": "Ft",
        "CZK": "Kč",
        "THB": "฿",
        "MYR": "RM",
        "HRK": "kn",
        "RON": "lei",
        "ILS": "₪",
        "CLP": "$",
        "AED": "د.إ",
        "COP": "$",
        "SAR": "﷼",
        "BGN": "лв",
        "PKR": "₨",
        "EGP": "£",
        "DZD": "د.ج",
        "KWD": "د.ك",
        "QAR": "﷼",
        "KES": "KSh",
        "VND": "₫",
        "ARS": "$",
        "TWD": "NT$",
        "BDT": "৳",
        "NPR": "₨",
        "IQD": "ع.د",
        "COP": "COL$",
        "LKR": "Rs",
        "UGX": "USh",
        "GHS": "GH₵",
        "RON": "RON",
        "MAD": "د.م.",
        "UZS": "so'm"
      };

    return currencySymbols[currencyCode] || "";
}

// // 示例用法
// console.log(getCurrencyCode("USD")); // 输出 "$"
// console.log(getCurrencyCode("EUR")); // 输出 "€"
// console.log(getCurrencyCode("JPY")); // 输出 "Unknown"，因为日元的符号不在列表中

var countryListAll = [
  { name: "Afghanistan", code: "AF" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "Andorra", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Brazil", code: "BR" },
  { name: "Brunei", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Colombia", code: "CO" },
  { name: "Costa Rica", code: "CR" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Greece", code: "GR" },
  { name: "Guatemala", code: "GT" },
  { name: "Honduras", code: "HN" },
  { name: "Hungary", code: "HU" },
  { name: "Hong Kong", code: "HK" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Ireland", code: "IE" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Kenya", code: "KE" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mexico", code: "MX" },
  { name: "Morocco", code: "MA" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nigeria", code: "NG" },
  { name: "Norway", code: "NO" },
  { name: "Pakistan", code: "PK" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Qatar", code: "QA" },
  { name: "Romania", code: "RO" },
  { name: "Russia", code: "RU" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "South Africa", code: "ZA" },
  { name: "South Korea", code: "KR" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Thailand", code: "TH" },
  { name: "Turkey", code: "TR" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "Vietnam", code: "VN" },
  { name: "Zimbabwe", code: "ZW" },
];
